"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reselect = require("reselect");

var _utils = require("./utils");

var rewardsStateSelector = function rewardsStateSelector(state) {
  return state.rewards;
};

var loadRewardsSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.loadRewards;
});
var loadRewardsDataSelector = (0, _reselect.createSelector)(loadRewardsSelector, function (loadRewards) {
  return loadRewards.data;
});

var loadRewardsDataFormatedSelector = function loadRewardsDataFormatedSelector(state) {
  var settings = state.settings;
  var loadRewardsData = loadRewardsDataSelector(state);
  return (0, _utils.formatRewardsData)(loadRewardsData, settings);
};

var loadRewardsIsLoadingSelector = (0, _reselect.createSelector)(loadRewardsSelector, function (loadRewards) {
  return loadRewards.isLoading;
});
var loadRewardsErrorSelector = (0, _reselect.createSelector)(loadRewardsSelector, function (loadRewards) {
  return loadRewards.error;
});
var loadRewardsCountSelector = (0, _reselect.createSelector)(loadRewardsDataSelector, function (loadRewards) {
  return loadRewards.nbHits;
});
var loadRewardsHasMoreDataSelector = (0, _reselect.createSelector)(loadRewardsDataSelector, function (loadRewardsData) {
  var _loadRewardsData$page = loadRewardsData.page,
      page = _loadRewardsData$page === void 0 ? 0 : _loadRewardsData$page,
      _loadRewardsData$nbPa = loadRewardsData.nbPages,
      nbPages = _loadRewardsData$nbPa === void 0 ? 0 : _loadRewardsData$nbPa;
  var currentPage = page + 1;
  return currentPage < nbPages;
});
var loadRewardSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.loadReward;
});
var loadRewardDataSelector = (0, _reselect.createSelector)(loadRewardSelector, function (loadReward) {
  return loadReward.data;
});

var loadRewardDataFormatedSelector = function loadRewardDataFormatedSelector(state) {
  var settings = state.settings;
  var loadRewardData = loadRewardDataSelector(state);
  return (0, _utils.formatRewardData)(loadRewardData, settings);
};

var loadRewardIsLoadingSelector = (0, _reselect.createSelector)(loadRewardSelector, function (loadReward) {
  return loadReward.isLoading;
});
var loadRewardErrorSelector = (0, _reselect.createSelector)(loadRewardSelector, function (loadReward) {
  return loadReward.error;
});
var loadRewardRedeemedUsersSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.loadRewardRedeemedUsers;
});
var loadRewardRedeemedUsersDataSelector = (0, _reselect.createSelector)(loadRewardRedeemedUsersSelector, function (loadRewardRedeemedUsers) {
  return loadRewardRedeemedUsers.data;
});
var loadRewardRedeemedUsersMetaSelector = (0, _reselect.createSelector)(loadRewardRedeemedUsersSelector, function (loadRewardRedeemedUsers) {
  return loadRewardRedeemedUsers.meta;
});
var loadRewardRedeemedUsersIsLoadingSelector = (0, _reselect.createSelector)(loadRewardRedeemedUsersSelector, function (loadRewardRedeemedUsers) {
  return loadRewardRedeemedUsers.isLoading;
});
var loadRewardRedeemedUsersErrorSelector = (0, _reselect.createSelector)(loadRewardRedeemedUsersSelector, function (loadRewardRedeemedUsers) {
  return loadRewardRedeemedUsers.error;
});
var createRewardSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.createReward;
});
var createdRewardIdSelector = (0, _reselect.createSelector)(createRewardSelector, function (createReward) {
  return createReward.createdRewardId;
});
var createRewardIsLoadingSelector = (0, _reselect.createSelector)(createRewardSelector, function (createReward) {
  return createReward.isLoading;
});
var createRewardErrorSelector = (0, _reselect.createSelector)(createRewardSelector, function (createReward) {
  return createReward.error;
});
var editRewardSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.editReward;
});
var editedRewardIdSelector = (0, _reselect.createSelector)(editRewardSelector, function (editReward) {
  return editReward.editedRewardId;
});
var editRewardIsLoadingSelector = (0, _reselect.createSelector)(editRewardSelector, function (editReward) {
  return editReward.isLoading;
});
var editRewardErrorSelector = (0, _reselect.createSelector)(editRewardSelector, function (editReward) {
  return editReward.error;
});
var deleteRewardSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.deleteReward;
});
var hasBeenDeletedSelector = (0, _reselect.createSelector)(deleteRewardSelector, function (deleteReward) {
  return deleteReward.hasBeenDeleted;
});
var deleteRewardIsLoadingSelector = (0, _reselect.createSelector)(deleteRewardSelector, function (deleteReward) {
  return deleteReward.isLoading;
});
var deleteRewardErrorSelector = (0, _reselect.createSelector)(deleteRewardSelector, function (deleteReward) {
  return deleteReward.error;
});
var extractRewardSelector = (0, _reselect.createSelector)(rewardsStateSelector, function (rewards) {
  return rewards.extractReward;
});
var extractRewardDataSelector = (0, _reselect.createSelector)(extractRewardSelector, function (extractReward) {
  return extractReward.data;
});
var extractRewardIsLoadingSelector = (0, _reselect.createSelector)(extractRewardSelector, function (extractReward) {
  return extractReward.isLoading;
});
var extractRewardErrorSelector = (0, _reselect.createSelector)(extractRewardSelector, function (extractReward) {
  return extractReward.error;
});
var _default = {
  loadRewardsSelector: loadRewardsSelector,
  loadRewardsDataSelector: loadRewardsDataSelector,
  loadRewardsDataFormatedSelector: loadRewardsDataFormatedSelector,
  loadRewardsIsLoadingSelector: loadRewardsIsLoadingSelector,
  loadRewardsErrorSelector: loadRewardsErrorSelector,
  loadRewardsCountSelector: loadRewardsCountSelector,
  loadRewardsHasMoreDataSelector: loadRewardsHasMoreDataSelector,
  loadRewardSelector: loadRewardSelector,
  loadRewardDataSelector: loadRewardDataSelector,
  loadRewardDataFormatedSelector: loadRewardDataFormatedSelector,
  loadRewardIsLoadingSelector: loadRewardIsLoadingSelector,
  loadRewardErrorSelector: loadRewardErrorSelector,
  loadRewardRedeemedUsersDataSelector: loadRewardRedeemedUsersDataSelector,
  loadRewardRedeemedUsersMetaSelector: loadRewardRedeemedUsersMetaSelector,
  loadRewardRedeemedUsersIsLoadingSelector: loadRewardRedeemedUsersIsLoadingSelector,
  loadRewardRedeemedUsersErrorSelector: loadRewardRedeemedUsersErrorSelector,
  createRewardSelector: createRewardSelector,
  createdRewardIdSelector: createdRewardIdSelector,
  createRewardIsLoadingSelector: createRewardIsLoadingSelector,
  createRewardErrorSelector: createRewardErrorSelector,
  editRewardSelector: editRewardSelector,
  editedRewardIdSelector: editedRewardIdSelector,
  editRewardIsLoadingSelector: editRewardIsLoadingSelector,
  editRewardErrorSelector: editRewardErrorSelector,
  deleteRewardSelector: deleteRewardSelector,
  hasBeenDeletedSelector: hasBeenDeletedSelector,
  deleteRewardIsLoadingSelector: deleteRewardIsLoadingSelector,
  deleteRewardErrorSelector: deleteRewardErrorSelector,
  extractRewardSelector: extractRewardSelector,
  extractRewardDataSelector: extractRewardDataSelector,
  extractRewardIsLoadingSelector: extractRewardIsLoadingSelector,
  extractRewardErrorSelector: extractRewardErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map